import { consumer } from '@tock/coretypes';

interface OfferingPriceDescriptionDisplayProps {
  priceDescription: string;
  minRequiredSpendCents?: number;
  priceVariability?: consumer.OfferingMinRequiredSpend.PriceVariability;
}

export const OfferingPriceDescriptionDisplay: React.FC<OfferingPriceDescriptionDisplayProps> = ({
  minRequiredSpendCents = 0,
  priceDescription,
}) => {
  if (minRequiredSpendCents === 0) {
    return null;
  }

  return <>{priceDescription}</>;
};
